import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import EventsPage from "@/pages/EventsPage";
import EventDetailPage from "@/pages/EventDetailPage";
import SponsorshipsPage from "@/pages/SponsorshipsPage";
import VendorsPage from "@/pages/VendorsPage";
import PurchaseSuccessPage from "@/pages/PurchaseSuccessPage";
import ArtistsPage from "@/pages/ArtistsPage";
import RequestPage from "@/pages/RequestPage";
import OwnerManualPage from "@/pages/OwnerManualPage";
import ProposalPage from "@/pages/ProposalPage";
import ServicesPage from "@/pages/ServicesPage";
import ProductsPage from "@/pages/ProductsPage";
import CompanyPage from "@/pages/CompanyPage";
import ContactPage from "@/pages/ContactPage";
import { PrivacyPage, TermsPage, RefundPage, ServicePolicyPage } from "@/pages/LegalPages";
import AcceptInvitePage from "@/pages/AcceptInvitePage";
import ServiceSuccessPage from "@/pages/ServiceSuccessPage";
import { ForgotPasswordPage, ResetPasswordPage } from "@/pages/PasswordResetPages";
import { TicketView, TicketLookup, PaymentSuccess } from "@/pages/TicketPages";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/events/:slug" element={<EventDetailPage />} />
            <Route path="/sponsorships" element={<SponsorshipsPage />} />
            <Route path="/sponsors" element={<SponsorshipsPage />} />
            <Route path="/vendors" element={<VendorsPage />} />
            <Route path="/artists" element={<ArtistsPage />} />
            <Route path="/request" element={<RequestPage />} />
            <Route path="/owner-manual" element={<OwnerManualPage />} />
            <Route path="/proposal/:id" element={<ProposalPage />} />
            <Route path="/purchase/success" element={<PurchaseSuccessPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/company" element={<CompanyPage />} />
            <Route path="/about" element={<CompanyPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/refund-policy" element={<RefundPage />} />
            <Route path="/service-policy" element={<ServicePolicyPage />} />
            <Route path="/admin/accept-invite" element={<AcceptInvitePage />} />
            <Route path="/admin/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/admin/reset-password" element={<ResetPasswordPage />} />
            <Route path="/services/success" element={<ServiceSuccessPage />} />
            <Route path="/ticket-lookup" element={<TicketLookup />} />
            <Route path="/ticket/:reference" element={<TicketView />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
          </Route>
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors theme="dark" />
    </AuthProvider>
  );
}

export default App;
